import { INavData } from '@coreui/angular';

export interface TranslatableNavData extends INavData {
  nameKey?: string;
  children?: TranslatableNavData[];
}

export const navItems: TranslatableNavData[] = [
  {
    name: 'Home',
    nameKey: 'nav.home',
    url: '/home',
    iconComponent: { name: 'cil-home' },
  },
  {
    name: 'Baby Predictor',
    nameKey: 'nav.baby_predictor',
    url: '/baby-predictor',
    iconComponent: { name: 'cil-child' },
  },
  {
    name: 'Customer Management',
    nameKey: 'nav.customer_management',
    url: '/data-storage',
    iconComponent: { name: 'cil-people' },
  },
  {
    name: 'Calendar',
    nameKey: 'nav.calendar',
    url: '/scheduling',
    iconComponent: { name: 'cil-calendar' },
  },
  {
    name: 'Payments',
    nameKey: 'nav.payments',
    url: '/payments',
    iconComponent: { name: 'cil-credit-card' },
  },
  {
    name: 'Google Reviews',
    nameKey: 'nav.google_reviews',
    url: '/reviews',
    iconComponent: { name: 'cil-star' },
  },
  {
    name: 'Budgeting',
    nameKey: 'nav.budgeting',
    url: '/budgeting',
    iconComponent: { name: 'cil-chart-pie' },
  },
  {
    name: 'Business Advisor',
    nameKey: 'nav.business_advisor',
    url: '/advisor',
    iconComponent: { name: 'cil-lightbulb' },
  },
  {
    name: 'Clinic Website',
    nameKey: 'nav.clinic_website',
    url: '/clinic-website',
    iconComponent: { name: 'cil-paint-bucket' },
  },
  {
    name: 'Account',
    nameKey: 'nav.account',
    iconComponent: { name: 'cil-settings' },
    children: [
      {
        name: 'Sub-Account Management',
        nameKey: 'nav.sub_account_management',
        url: '/user-management',
        iconComponent: { name: 'cil-user' },
      },
      {
        name: 'Billing',
        nameKey: 'nav.billing',
        url: '/billing',
        iconComponent: { name: 'cil-wallet' },
      },
      {
        name: 'Invoice',
        nameKey: 'nav.invoice',
        url: '/invoice',
        iconComponent: { name: 'cil-file' },
      },
      {
        name: 'Help & Support',
        nameKey: 'nav.help_support',
        url: '/support',
        iconComponent: { name: 'cil-life-ring' },
      },
      {
        name: 'FAQ',
        nameKey: 'nav.faq',
        url: '/faq',
        iconComponent: { name: 'cil-speech' },
      },
      {
        name: 'Privacy Policy',
        nameKey: 'nav.privacy_policy',
        url: '/privacy',
        iconComponent: { name: 'cil-shield-alt' },
      },
      {
        name: 'Terms & Conditions',
        nameKey: 'nav.terms_conditions',
        url: '/terms',
        iconComponent: { name: 'cil-description' },
      },
      {
        name: 'Language',
        nameKey: 'nav.language',
        iconComponent: { name: 'cil-language' },
        children: [
          { name: 'English', url: '/lang/en', class: 'lang-option' },
          { name: 'Français', url: '/lang/fr', class: 'lang-option' },
          { name: 'Español', url: '/lang/es', class: 'lang-option' },
          { name: 'Deutsch', url: '/lang/de', class: 'lang-option' },
        ],
      },
      {
        name: 'Change Password',
        nameKey: 'nav.change_password',
        url: '/reset',
        iconComponent: { name: 'cil-lock-locked' },
      },
      {
        name: 'Logout',
        nameKey: 'nav.logout',
        url: '/logout',
        class: 'logout',
        iconComponent: { name: 'cil-account-logout' },
      },
    ],
  },
];
